export const get = ({ params }) => {
    const url = constructURL({ params })
    return fetch(url)
}

// guests is the shared store's { adults, children } search party, or null before one is known
export const getPartyParams = guests => guests
    ? { numberOfGuests: guests.adults, numberOfChildren: guests.children }
    : {}

// roomType is the bedroom count the calendar asked for (null for all; 0 studio; negative hotel room)
const getResidenceNoun = roomType =>
    roomType === null || roomType === undefined ? 'residence' :
        roomType > 0 ? `${roomType}-bedroom residence` :
            roomType < 0 ? 'hotel room' : 'studio'

// the API adds unavailableForParty only once it has judged the party; the banner reads largestSleeps, which follows the room type
export const getPartyAvailability = (json, guests, roomType) => guests && json.unavailableForParty && typeof json.unavailableForParty === 'object'
    ? {
        partySize: guests.adults + guests.children,
        largestSleeps: json.largestSleeps,
        residenceNoun: getResidenceNoun(roomType),
    }
    : null

const constructURL = ({ params }) => {
    const endpoint = window.location.origin + '/api/availability'
    const url = new URL(endpoint)
    Object.entries(params).forEach(e => url.searchParams.append(...e))
    return url
}
